import { KycApprovalStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';
import { AcceptanceStatus, GetKYCInvestorInstanceRes } from '@dealstack/shared/lib/generated';

export const getDeclarationsApprovalStatus = (
	investor?: GetKYCInvestorInstanceRes
): KycApprovalStatus => {
	const declarations = investor?.declarations ?? [];

	if (!declarations.length) {
		return null;
	}

	if (
		declarations.some(
			(d) =>
				d.status === AcceptanceStatus.REJECTED || d.status === AcceptanceStatus.REREQUESTED
		)
	) {
		return AcceptanceStatus.REJECTED;
	}

	if (declarations.every((d) => d.status === AcceptanceStatus.APPROVED)) {
		return AcceptanceStatus.APPROVED;
	}

	return AcceptanceStatus.PENDING;
};
